export const CLEAR_SHIPPING_RATES_ACTION = 'Rollo/CLEAR_SHIPPING_RATES_ACTION';

export const toggleClearShippingRates = (shouldClearShippingRates: boolean) => ({
  type: CLEAR_SHIPPING_RATES_ACTION,
  payload: shouldClearShippingRates,
});
